// dev_lp i18n — language metadata (endonyms + text direction)
// Used by the language switcher and for dynamic dir/lang on the dev landing page.

export type LangDir = "rtl" | "ltr";

export interface LangMeta {
  code: string; // i18next locale code
  label: string; // endonym (shown in the switcher)
  dir: LangDir;
}

export const DEV_LP_LANGUAGES: LangMeta[] = [
  { code: "he", label: "עברית", dir: "rtl" },
  { code: "en", label: "English", dir: "ltr" },
  { code: "it", label: "Italiano", dir: "ltr" },
  { code: "de", label: "Deutsch", dir: "ltr" },
  { code: "ja", label: "日本語", dir: "ltr" },
  { code: "es", label: "Español", dir: "ltr" },
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "pt-BR", label: "Português (Brasil)", dir: "ltr" },
  { code: "fr", label: "Français", dir: "ltr" },
  { code: "ru", label: "Русский", dir: "ltr" },
];

export const DEV_LP_DEFAULT_LANG = "he";

export const getLangDir = (code: string): LangDir =>
  DEV_LP_LANGUAGES.find((l) => l.code === code)?.dir ?? "rtl";
